import App from './App.vue';

Vue.config.productionTip = false;
Vue.config.devtools = true;

window._$ = window.jQuery = require('jquery');

new Vue({
    el: "#app",
    render: h => h(App)
});